import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { dispatchCreateAlert } from '@Pages/Alerts/AlertsComponents/AlertCreateDialog/AlertCreateDialogActions';
import Button from '@Components/Button';
import InnerHTML from '@Components/InnerHTML';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithErrorLayout.scss';

export default function DialogWithErrorLayout(props) {
  const {
    selfClose,
    onYesClick,
    className,
    headerClassName,
    headerTitleClassName,
    contentClassName,
    footerClassName,
    header,
    children,
    content,
    yesLabel,
    traceInfo,
    link,
    crumb,
  } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  const createAlert = () => {
    selfClose();
    dispatchCreateAlert(crumb);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(traceInfo.traceparent.toUpperCase());
  };

  const getTraceErrorPreHeaderContent = () => {
    if (traceInfo && (traceInfo.traceparent || traceInfo.timestamp)) {
      return (
        <div className="dialog-with-error-layout-pre_header">
          {traceInfo.timestamp && (
            <InnerHTML tag="div" html={traceInfo.timestamp instanceof Date ? traceInfo.timestamp.toISOString() : traceInfo.timestamp} />
          )}
          {traceInfo.traceparent && (
            <div className="dialog-with-error-layout-pre_header--trace-label">
              Reference:&nbsp;
              <Button
                buttonConfig={{
                  className: 'dialog-with-error-layout-pre_header--trace-value',
                  label: traceInfo.traceparent.toUpperCase(),
                  type: 'link',
                  size: 'sm',
                  title: 'Copy to Clipboard',
                  e2eName: 'traceparent',
                }}
                onClick={copyToClipboard}
              />
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const getLinkContent = () => {
    if (link) {
      return (
        <span className="dialog-with-error-layout-content-link">
          {link.preMessage}
          <a href={link.url} target="_blank" rel="noreferrer">
            {link.linkText}
          </a>
          {link.postMessage}
        </span>
      );
    }
    return null;
  };

  return (
    <DialogsWithIcon
      {...props}
      size="md"
      className={classnames(className, 'dialog-with-error-layout')}
      character="!"
      layoutType="error"
      headerClassName={classnames(headerClassName, 'dialog-with-error-layout-header rx-border-none')}
      headerTitleClassName={classnames(headerTitleClassName, 'dialog-with-error-layout-header-title')}
      contentClassName={classnames(contentClassName, 'dialog-with-error-layout-content-wrapper')}
      footerClassName={classnames(footerClassName, 'dialog-with-error-layout-footer rx-border-none', { 'alert-footer': crumb })}
      header={header}
      preHeader={getTraceErrorPreHeaderContent()}
      footer={
        <>
          {crumb && (
            <Button
              buttonConfig={{ type: 'link', label: 'Alert', size: 'sm', title: 'Alerts', e2eName: 'breadcrumb-alert' }}
              iconConfig={{ name: 'notifications', size: 'md' }}
              onClick={createAlert}
            />
          )}
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              label: yesLabel,
              e2eName: 'dialog-error-ok',
            }}
            iconConfig={{ name: 'chevron-right' }}
            onClick={clickHandler}
          />
        </>
      }>
      {children || content}
      {getLinkContent()}
    </DialogsWithIcon>
  );
}

DialogWithErrorLayout.defaultProps = {
  yesLabel: 'Got it',
};

DialogWithErrorLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headerTitleClassName: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  traceInfo: PropTypes.object,
  link: PropTypes.object,
  crumb: PropTypes.object,
};
